import React from "react";

const DashLogoutIcon = ({ width, height, color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8116 0H2.79036C1.75796 0 0.930176 0.89 0.930176 2V6H2.79036V2H15.8116V16H2.79036V12H0.930176V16C0.930176 16.5304 1.12616 17.0391 1.47501 17.4142C1.82386 17.7893 2.29701 18 2.79036 18H15.8116C16.305 18 16.7781 17.7893 17.127 17.4142C17.4758 17.0391 17.6718 16.5304 17.6718 16V2C17.6718 0.89 16.8347 0 15.8116 0ZM7.51522 12.58L8.83595 14L13.4864 9L8.83595 4L7.51522 5.41L9.92416 8H0.930176V10H9.92416L7.51522 12.58Z"
        fill="#FF4400"
      />
    </svg>
  );
};

export default DashLogoutIcon;
